// extracted by mini-css-extract-plugin
module.exports = {"modalCard":"WalletModalStepTwo_modalCard__1NjZx","radioButton":"WalletModalStepTwo_radioButton__1J16V","active":"WalletModalStepTwo_active__3-_y1"};